module.exports = __webpack_public_path__ + "static/media/ru.7611c25d.svg";